import { render } from "./EditSubscriber.vue?vue&type=template&id=b5bb3e0c&scoped=true"
import script from "./EditSubscriber.vue?vue&type=script&lang=js"
export * from "./EditSubscriber.vue?vue&type=script&lang=js"

import "./EditSubscriber.vue?vue&type=style&index=0&id=b5bb3e0c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5bb3e0c"]])

export default __exports__